<template>
      <section>
            <div class="container">
                  <div class="row">
                        <div class="col-sm-12">
                              
                              <div class="wrapper-page">
                                    
                                    <div class="account-pages">
                                          <div class="account-box">
                                                <div class="account-logo-box">
                                                      <h2 class="text-uppercase text-center">
                                                            <a href="" class="text-success">
                                                                  <span style="color:rgb(49 64 144) !important;font-size:1rem;">特许私人财富管理师(CPWM<sup>&#174;</sup>)</span>
                                                            </a>
                                                      </h2>
                                                      <h6 class="text-uppercase text-center font-bold mt-4" style="font-size: 2rem;color: #434344;margin-top: .7rem !important;">考试与认证系统</h6>
                                                </div>
                                                <div class="account-content">
                                                    
                                                            
                                                            <div class="form-group m-b-20 row">
                                                                  <div class="col-12">
                                                                        <label for="emailaddress">手机/邮箱</label>
                                                                        <input class="form-control" type="email" id="emailaddress" required="" placeholder="请输入您的邮箱或者手机" v-model="mobile">
                                                                  </div>
                                                            </div>
                                                            
                                                            <div class="form-group row m-b-20">
                                                                  <div class="col-12">
                                                                        
                                                                        <label for="password">手机验证码/密码</label>
      
                                                                        
                                                                              <label v-text="requestsmsH"
                                                                                     v-on:click="requestsms"
                                                                                     v-show="sendAuthCode"
                                                                                     class="requestsmsstyle" style="padding:0px 5px;float:right;"></label>
                                                                              <label v-text="requestsmsH"
                                                                                     v-show="!sendAuthCode"  style="padding:0px 5px;float:right;"></label>
                                                                        
                                                                        
                                                                        <input class="form-control" type="password" required="" id="password" placeholder="请输入您的验证码或者密码" v-model="yzm">
                                                                  </div>
                                                            </div>
                                                            
                                                           
                                                            
                                                            <div class="form-group row text-center m-t-10">
                                                                  <div class="col-12">
                                                                        <button class="btn btn-block btn-gradient waves-effect waves-light" type="submit" v-on:click="memberlogin">登录</button>
                                                                  </div>
                                                            </div>
                                                      
                                              
                                                      
                                                      <div class="row m-t-50">
                                                            <div class="col-sm-12 text-center">
                                                                  <p class="text-muted">如登录中遇到任何问题，请拨打咨询热线 021-31190952</p>
                                                            </div>
                                                      </div>
                                                
                                                </div>
                                          </div>
                                    </div>
                                    <!-- end card-box-->
                              
                              
                              </div>
                              <!-- end wrapper -->
                        
                        </div>
                  </div>
            </div>
      </section>
</template>

<script>
      export default {
            name: 'index',
            data() {
                  return {
                        requestsmsH: '获取验证码',
                        sendAuthCode: true,
                        mobile:this.mobile,
                        yzm:this.yzm
                  }
            },
            mounted(){
                  //window.body.className="bg-accpunt-pages"
                  //document.documentElement.style.fontSize ='14px';
                  document.getElementsByTagName("body")[0].className="bg-accpunt-pages";
            },
            methods: {
                  memberlogin:function(){
                        let data = {
                              mobile:this.mobile,
                              yzm:this.yzm

                        }
                        //用户提交
                        this.$axios({
                              method: "POST",
                              url: "/api/member2/memberlogin",
                              data: data,

                        }).then(function OnSuccess(response) {
                              if(response.data.code==0){
                                    //alert(response.data.msg);
                                    localStorage.setItem('membertoken',response.data.membertoken);
                                    swal(
                                          {
                                                html: '<p style="color:#000000;text-align: left;font-weight:900;">欢迎进入特许私人财富管理师考试与认证系统，请确认您的个人信息后，选择：参加考试，请点击<b style="font-weight:900;color:rgb(49 64 144) !important;">[考试报名]</b>；申请认证，请点击<b style="font-weight:900;color:rgb(49 64 144) !important;">[首次认证]</b>；申请再认证，请点击<b style="font-weight:900;color:rgb(49 64 144) !important;">[再认证]</b></p>',
                                                text: '',
                                                type: '',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    ).then(function () {
                                          //this.$router.push({path:'/main'});
                                          window.location.href="/member2/#/main"
                                    })
                                    
                                    
                              }else{
                                    //alert(response.data.msg);
                                    swal(
                                          {
                                                title: response.data.msg,
                                                text: '',
                                                type: 'error',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                              }
                        
                        }.bind(this)).catch(function OnError(response) {
                              console.log(response)
                        })
                  },
                  requestsms: function () {
                        var mobile = this.mobile;
                        if (mobile == null) {
                              //alert('手机号不能为空！');
                              swal(
                                    {
                                          title: '手机号不能为空！',
                                          text: '',
                                          type: 'error',
                                          confirmButtonColor: '#4fa7f3',
                                    }
                              )
                              return false;
                        }
                        this.$axios({
                              method: 'get',
                              url: '/api/member2/downticketsendmsg/' + mobile
                        }).then(function onSuccess(response) {
                              //console.log(response.data.code);
                              if (response.data.code === '0') {
                                    this.requestsmsdaoshu();
                              } else {
                                    //alert('短信发送失败，请稍后尝试，或者联系系统管理员');
                                    swal(
                                          {
                                                title: '短信发送失败，请稍后尝试，或者联系系统管理员！',
                                                text: '',
                                                type: 'error',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                                    console.log(response)
                              }

                        }.bind(this)).catch(function onError() {
                              //alert('短信发送失败，请稍后尝试，或者联系系统管理员');
                              swal(
                                    {
                                          title: '短信发送失败，请稍后尝试，或者联系系统管理员！',
                                          text: '',
                                          type: 'error',
                                          confirmButtonColor: '#4fa7f3',
                                    }
                              )
                              //console.log(response)
                        })
                  },
                  requestsmsdaoshu: function () {
                        this.sendAuthCode = false,
                              this.requestsmsH = '60秒后可重新发送'
                        var miao = 60;
                        var stopinterval = setInterval(() => {
                              miao--;
                              if (miao > 0) {
                                    this.requestsmsH = miao + '秒后可重新发送';
                              } else {
                                    this.sendAuthCode = true;
                                    this.requestsmsH = '（获取验证码）';
                                    clearInterval(stopinterval);
                              }

                        }, 1000);

                  }
                  //method over


            }
            //mounted over


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body{
      background-color: #5d6dc3;
      background: linear-gradient(to top, #5d6dc3, #3c86d8);
      padding-bottom: 0;
      min-height: 100px;
}
  
     
</style>



// WEBPACK FOOTER //
// src/components/login.vue